import React, { useState, useEffect, useContext } from "react";
import "./Top.scss";
import StyleContext from "../../contexts/StyleContext";

export default function Top() {
  const { isDark } = useContext(StyleContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const scrollFunction = () => {
      if (window.scrollY > 20) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", scrollFunction);
    // Initial check
    scrollFunction();

    // Cleanup listener on unmount
    return () => window.removeEventListener("scroll", scrollFunction);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Bonus: makes the scroll itself smooth!
    });
  };

  return (
    <button 
      onClick={scrollToTop} 
      id="topButton" 
      // Safely combines the "show" class and the "dark-mode" class
      className={`${visible ? "show" : ""} ${isDark ? "dark-mode" : ""}`.trim()}
      title="Go to top"
    >
      <i className="fas fa-hand-point-up" aria-hidden="true"></i>
    </button>
  );
}
